/* eslint-disable react/jsx-key */
import React from 'react';
import stringConstants from 'app/shared/constants/StringConstants';

const streetEasyUrl = 'https://streeteasy.com/agent-resources/advertise/reach-millions-active-buyers-renters-nyc/';
const learnMoreUrl = 'http://www.zillow.com/rental-property-advertising';

const ErrorMessageConstants = {
    LOCATION_RESTRICTION: {
        NYC: [
            'This listing may not get published. Please visit ',
            <a href={streetEasyUrl} target="_blank" rel="noopener noreferrer">StreetEasy</a>,
            ' to list a rental in this area of New York.',
        ],
        MF_REQUIRED: (brand) => {
            let queryParams = '?utm_medium=referral&utm_content=learnmorelink';

            if (brand === stringConstants.UNFORMATTED_BRAND_NAMES.hotpads) {
                queryParams += '&utm_source=hotpads&utm_campaign=hotpads_add_property';
            } else if (brand === stringConstants.UNFORMATTED_BRAND_NAMES.zillow) {
                queryParams += '&utm_source=zrm&utm_campaign=zrm_add_property';
            }

            return [
                'This listing may not get published. ',
                <a href={`${learnMoreUrl}${queryParams}`} target="_blank" rel="noopener noreferrer">Learn more</a>,
                ' about posting rentals in communities of 50 units or more.',
            ];
        },
        DUPLICATE: {
            MESSAGE: 'This property is already posted.',
            LINK_TEXT: 'View Listing',
        },
    },
    DEFAULT_PHOTO_ERROR: 'There was an error with your photo upload. Please check the field for errors and try again.',
    DELETE_LAST_PHOTO_ACTIVE_LISTING_ERROR: 'Active listings must have at least one photo',
    DELETE_PHOTO_ERROR: 'There was an error deleting the photo. Please, try again.',
    DEFAULT_ERROR: 'Sorry, something went wrong. Please try again later.',
    SINGLE_FAMILY_NO_ACTIVE_CONTRACT: 'There is no active contract. Please contact rentalshelp@zillowgroup.com.',
    SINGLE_FAMILY_CANNOT_RETRIEVE_CONTRACTS: 'Cannot retrieve active contacts, please try again later.',
};

export default ErrorMessageConstants;
